import { useSelector } from 'react-redux'

import GitHubWidgetCard from 'components/integrations/GitHubWidgetCard'

import CustomFieldCategory from './CustomFieldCategory'
import { selectContactDetailsColumnWidgetCards } from './selectors'

const INTEGRATION_COMPONENTS = {
  github: GitHubWidgetCard,
}

export default function WidgetCards() {
  const widgetCards = useSelector(selectContactDetailsColumnWidgetCards)
  return (
    <>
      {widgetCards &&
        widgetCards.map(widgetCard => {
          const { id, key, categoryType, name, provider } = widgetCard
          const IntegrationComponent = INTEGRATION_COMPONENTS[provider]
          if (provider) {
            if (IntegrationComponent)
              return <IntegrationComponent key={provider} />
            return null
          }
          return (
            <CustomFieldCategory
              key={id}
              categoryId={id}
              categoryKey={key}
              categoryName={name}
              categoryType={categoryType}
            />
          )
        })}
    </>
  )
}
